import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const wixStyleReactEnvironmentProviderDriverFactory = (
  base: UniDriver,
) => {
  return {
    ...baseUniDriverFactory(base),
  };
};
